import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { BudgetPlanSummary } from 'types'

interface Props {
    plans: BudgetPlanSummary[]
    onHide: () => void
    onCreate: () => void
    onSelect: (plan: BudgetPlanSummary) => void
    currentPlan: BudgetPlanSummary
}

function PlanSelectionModal({ plans, onHide, onCreate, onSelect, currentPlan }: Props) {
    const [selectedPlan, setSelectedPlan] = useState<number | null>(null)

    useEffect(() => {
        const idx = plans.findIndex(p => p.id === currentPlan.id)
        setSelectedPlan(idx)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const planSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = parseInt(e.target.value)
        setSelectedPlan(value)
        const plan = plans[value]
        onSelect(plan)
    }

    return <Modal show={true} onHide={onHide}>
        <Modal.Header closeButton>
            <Modal.Title>Select plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form onSubmit={(e: React.FormEvent) => e.preventDefault()}>
                <Form.Group>
                    <Form.Label>Validity</Form.Label>
                    <Form.Control
                        as="select"
                        onChange={planSelected as any}
                        value={selectedPlan !== null ? selectedPlan : ""}
                    >
                        {plans.map((plan, i) => (
                            <option key={i} value={i}>{plan.validFrom} to {plan.validTo}</option>
                        ))}
                    </Form.Control>
                </Form.Group>
                <Button variant="link" onClick={onCreate}>Create new</Button>
            </Form>
        </Modal.Body>
    </Modal>
}

export default PlanSelectionModal
